import { useExplorerStore } from "@/FundExplorer/store";

const UK_INTERMEDIARY = "1186";

export default function useShouldDisplayFocusFunds() {
	const audienceId = useExplorerStore((store) => store.config?.audience);
	return false && audienceId === UK_INTERMEDIARY;
}
